import { WebinarStatus } from '@core/types';
import { DateTime, Interval } from 'luxon';
import { getI18n, useTranslation } from 'react-i18next';

export const WebinarLiveIndicator = ({ now, startedTime, status }: { now: DateTime; startedTime?: string; status: WebinarStatus }) => {
    const { t } = useTranslation();

    if (!startedTime) {
        return null;
    }

    const interval = Interval.fromDateTimes(DateTime.fromISO(startedTime).toLocal().setLocale(getI18n().language), now);

    return (
        <div className="bg-white border-2 border-warning rounded-full flex items-center ps-2.5 pe-3 py-0.5">
            <span className="relative size-2 flex me-2">
                <span className="animate-ping absolute h-full w-full inline-flex rounded-full bg-warning opacity-75"></span>
                <span className="relative size-2 inline-flex rounded-full bg-warning"></span>
            </span>
            <span className="text-warning text-xl leading-none uppercase me-1em">{t('Webinar.Live')}</span>
            {`${interval.toDuration().toFormat('hh:mm:ss')}`}
        </div>
    );
};
